import { Action } from 'redux';

import { IRemoteRefreshScheduleInfo } from '../../../ts/models/IRemoteRefreshScheduleInfo';
import { ChangeRemoteExtractRefreshExpectedDuration } from '../AppActionTypes';

export interface ChangeRemoteExtractRefreshExpectedDurationAction extends Action {
  scheduleInfo: IRemoteRefreshScheduleInfo;
}

export function changeRemoteExtractRefreshExpectedDuration(scheduleInfo: IRemoteRefreshScheduleInfo): ChangeRemoteExtractRefreshExpectedDurationAction {
  return {
    type: ChangeRemoteExtractRefreshExpectedDuration,
    scheduleInfo,
  };
}
